/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

/**
 * Custom error to indicate invalid data in visualizations.
 */
export class VisInvalidDataError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VisInvalidDataError';
  }
}
